<template>
    <div class="mine-function">
        <div class="mine-function-header flex align-center">
            <img
                class="mine-function-title-image"
                src="@/assets/images/user/function.png"
                alt=""
            />
            <p class="mine-function-title">我的功能</p>
        </div>
        <div class="mine-function-wrap flex justify-between align-center">
            <div
                class="mine-function-item flex flex-column justify-center align-center"
                v-for="(item, index) in dataList"
                :key="index"
                @click="handleItem(item)"
            >
                <img :src="item.icon" alt="" />
                <p>{{ item.name }}</p>
            </div>
        </div>
        <Dialog
            :show.sync="showDialog"
            @hideDialog="hideDialog"
            @handleLeftBtn="showDialog = false"
            @handleConfirm="handleConfirm"
            leftBtnText="我知道了"
            rightBtnText="去认证"
            content="如需查看车辆账单，请先认证车辆！"
        />
    </div>
</template>

<script>
import Dialog from "@/components/base/dialog/dialog.vue";
import { excelOpenParkingRecord } from "@/api/api";
export default {
    name: "MineFunction",
    components: {
        Dialog,
    },

    data() {
        return {
            showDialog: false,
            dataList: [
                {
                    icon: require("@/assets/images/user/parkingrecord.png"),
                    name: "停车记录",
                    route: "/record",
                },
                {
                    icon: require("@/assets/images/user/parkingbill.png"),
                    name: "停车账单",
                    route: "/bill",
                },
                {
                    icon: require("@/assets/images/user/mycar.png"),
                    name: "我的车辆",
                    route: "/mycar",
                },

                {
                    icon: require("@/assets/images/user/privacy.png"),
                    name: "免密设置",
                    route: "/mycar/confidentialitySetting",
                },

                {
                    icon: require("@/assets/images/user/privacy.png"),
                    name: "测试导出",
                    route: "/mycar/confidentialitySetting",
                },
            ],
        };
    },
    mounted() {},
    methods: {
        handleItem(item) {
            if (item.name === "测试导出") {
         window.location.href = 'http://10.201.75.30/qgzlpt/openParkingRecordController/excelOpenParkingRecord?filterTime=&parkName=&parkCode=&plateNum=&status=&zt=1&isPay=&flag=&timeType=0&monthlyType=&parkingRecordId=&areaCode=350505&beginTime=2023-12-01%2000%3A00%3A00&endTime=2023-12-31%2023%3A59%3A59&token=24ce805783f5401888cfb2e6efb53e8b'
                return;
            }
            this.$router.push(item.route);
        },
        hideDialog(data) {
            this.showDialog = data;
        },
        // 车辆未认证去认证
        handleConfirm() {
            // this.$router.push('/mycar/vehicleCertification')
            this.$router.push("/mycar");
        },
    },
};
</script>

<style lang="less" scoped>
.mine-function {
    width: 702px;
    min-height: 256px;
    background: #ffffff;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    .mine-function-header {
        padding: 24px 32px;
        .mine-function-title-image {
            width: 32px;
            height: 32px;
            margin-right: 16px;
        }
        .mine-function-title {
            color: #666666;
            font-size: 26px;
        }
    }
    .mine-function-wrap {
        display: flex;
        flex-wrap: wrap;
        .mine-function-item {
            // flex: 1;
            // height: 100%;
            width: 33%;
            height: 160px;
            img {
                width: 64px;
                height: 64px;
                margin-bottom: 16px;
            }
            p {
                color: #999;
                font-size: 26px;
            }
            &:nth-child(2) {
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    left: 0;
                    width: 1px;
                    height: 160px;
                    background: #666666;
                    opacity: 0.1;
                    border-radius: 1px;
                }
                &::before {
                    content: "";
                    position: absolute;
                    right: 0;
                    width: 1px;
                    height: 160px;
                    background: #666666;
                    opacity: 0.1;
                    border-radius: 1px;
                }
            }
        }
    }
}
</style>
